export const serverHost =
  process.env.NODE_ENV === "production" ? process.env.REACT_APP_DO_HOST : process.env.REACT_APP_LOCALHOST;
export const clientHost =
  process.env.NODE_ENV === "production" ? process.env.REACT_APP_DO_HOST : process.env.REACT_APP_CLIENTHOST;
export const diagramLimit = 15;
export const nameSize = 16; // For entities, relationships and attributes
export const fontSize = 13; // In the canvas stage
export const textHeight = 500; // Height of the name text on canvas
export const toolbarHeight = 60;
export const dragBoundOffset = 2; // Elements cannot get closer to the edges of the canvas than this number allows
export const stageWidth = 2560;
export const stageHeight = 1412;
export const entityWidth = 100;
export const entityWidthCrows = 155;
export const entityHeight = 50;
//export const entityHeightCrows = 70;
export const entityTextWidth = 90;
export const entityTextWidthCrows = 140;
export const entityWeakOffset = 10;
export const extensionRadius = 20;
export const relationshipWidth = 60; // Measured from the center to either the left or right vertex
export const relationshipHeight = 35; // Measured from the center to either the top or bottom vertex
export const relationshipTextWidth = 90;
export const attributeRadiusX = 50;
export const attributeRadiusY = 27;
export const attributeTextWidth = 80;
export const multivaluedAttributeOffset = 5;
export const labelTextSize = 200;
export const labelMinWidth = 40;
export const labelMinHeight = 40;
export const labelMaxWidth = 400;
export const labelMaxHeight = 400;
export const spawnRadius = 110;
export const weakRelationshipOffset = 6;
export const anchorLength = 30;
export const savePeriod = 30000; // How often auto-saving is triggered in ms

export const resizeRectSize = 1000; // Rectangle used for resizing labels
export const timeout = 10000; // Requests timeout after this many milliseconds
